import { z } from "zod";

export type ConfigValue =
  | number
  | string
  | boolean
  | ConfigValue[]
  | { [name: string]: ConfigValue }
  | null
  | undefined;

// Cannot be an array as they are variable length which means structural differences between languages.
// Cannot be undefined as that is the same as unset.
export type MultilingualizableConfigValue = Exclude<ConfigValue, undefined | ConfigValue[]>;

export const configValueSchema: z.ZodType<ConfigValue> = z.lazy(() =>
  z.union([
    z.number(),
    z.string(),
    z.boolean(),
    z.array(configValueSchema),
    z.record(z.string(), configValueSchema),
    z.null(),
    z.undefined(),
  ]),
);
